var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xBC\x96\xE7\xBB\x84 19"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xBC\x96\xE7\xBB\x84 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 8 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6005 10.2429L18.626 6.20113L20.052 4.79883L24.716 9.54176C25.0987 9.93089 25.0987 10.5549 24.716 10.9441L20.2072 15.5291L18.7812 14.1268L22.6005 10.2429Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 9 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.1348C9 11.8211 11.6863 9.13477 15 9.13477H23.7311V11.1348H15C12.7909 11.1348 11 12.9256 11 15.1348V19.4628H9V15.1348Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_982_2719",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 31
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6\xE7\xBB\x93\xE5\x90\x88"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_982_2719",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.494 0.5H0V16.824V30.8161H10.494H29.1501V16.824H10.494V0.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.494 0.5H0V16.824V30.8161H10.494H29.1501V16.824H10.494V0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5V-0.5H-1V0.5H0ZM10.494 0.5H11.494V-0.5H10.494V0.5ZM0 30.8161H-1V31.8161H0V30.8161ZM29.1501 30.8161V31.8161H30.1501V30.8161H29.1501ZM29.1501 16.824H30.1501V15.824H29.1501V16.824ZM10.494 16.824H9.49402V17.824H10.494V16.824ZM0 1.5H10.494V-0.5H0V1.5ZM1 16.824V0.5H-1V16.824H1ZM1 30.8161V16.824H-1V30.8161H1ZM10.494 29.8161H0V31.8161H10.494V29.8161ZM29.1501 29.8161H10.494V31.8161H29.1501V29.8161ZM28.1501 16.824V30.8161H30.1501V16.824H28.1501ZM10.494 17.824H29.1501V15.824H10.494V17.824ZM9.49402 0.5V16.824H11.494V0.5H9.49402Z",
    fill: "white",
    mask: "url(#path-3-inside-1_982_2719)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_982_2719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7.5H7V21.5H23V7.5ZM5 5.5V23.5H25V5.5H5Z",
    fill: "#333333"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.eeaf7cdcc5bef9bb86ec25ee94afbbb4.svg";
export { ForwardRef as ReactComponent };